document.querySelector('.product-selector-dropdown .product-selector-select').addEventListener('click', function (event) {
  this.nextElementSibling.classList.toggle('open');
  //document.querySelector('.product-selector-modal-options').classList.toggle('open');
});
window.addEventListener('click', function (e) {
  const select = document.querySelector('.product-selector-dropdown .product-selector-select');
  if (!select.contains(e.target)) {
    select.nextElementSibling.classList.remove('open');
    //document.querySelector('.product-selector-modal-options').classList.remove('open');
  }
});